import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Extensions from "@/pages/Extensions";
import IVRs from "@/pages/IVRs";
import CallLogs from "@/pages/CallLogs";
import Settings from "@/pages/Settings";
import ConfigExport from "@/pages/ConfigExport";
import {
  Departments, Trunks, InboundRoutes, OutboundRoutes, RingGroups, Queues, Users,
} from "@/pages/CrudPages";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/extensions" element={<Extensions />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/trunks" element={<Trunks />} />
              <Route path="/inbound" element={<InboundRoutes />} />
              <Route path="/outbound" element={<OutboundRoutes />} />
              <Route path="/ivr" element={<IVRs />} />
              <Route path="/ring-groups" element={<RingGroups />} />
              <Route path="/queues" element={<Queues />} />
              <Route path="/call-logs" element={<CallLogs />} />
              <Route path="/users" element={<Users />} />
              <Route path="/config" element={<ConfigExport />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
